export default __webpack_public_path__ + "static/media/avatar_128.8728403b.png";